import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { USDollar } from "~/functions";
import api from "~/services/api";
import useReportsStore from "~/store/reportsStore";

export default function ChartNetValues({
  onCompareToggle,
  dreConfigId = null,
  dateType = null,
}) {
  const filial = useSelector((state) => state.auth.filial);
  const { filters } = useReportsStore();
  const period = filters.periodsByReport?.["Profit&Loss"] || filters.period;
  const [totals, setTotals] = useState({
    total: 0,
    income: 0,
    expenses: 0,
    differencePeriodBefore: 0,
    totalBefore: 0,
    compareMonth: null,
  });

  function updateData() {
    const from_date = format(period.from, "yyyy-MM-dd");
    const until_date = format(period.to, "yyyy-MM-dd");
    const useCompare =
      period?.label === "Month vs Month" || period?.label === "Year vs Year";
    const from_date_before =
      useCompare && period?.compare_from
        ? format(period.compare_from, "yyyy-MM-dd")
        : null;
    const until_date_before =
      useCompare && period?.compare_to
        ? format(period.compare_to, "yyyy-MM-dd")
        : null;
    const compareQuery =
      useCompare && from_date_before && until_date_before
        ? `&from_date_before=${from_date_before}&until_date_before=${until_date_before}`
        : "";
    const dreQuery = dreConfigId ? `&dre_id=${dreConfigId}` : "";
    const dateTypeQuery = dateType ? `&date_type=${dateType}` : "";

    api
      .get(
        `/receivables-dashboard/profit-and-loss?from_date=${from_date}&until_date=${until_date}${compareQuery}${dreQuery}${dateTypeQuery}`
      )
      .then((response) => {
        setTotals(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    updateData();
  }, [period, dreConfigId, dateType]);

  useEffect(() => {
    updateData();
  }, [filial, dreConfigId, dateType]);

  return (
    <div className="w-full p-2 px-4 border rounded-lg mb-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex flex-col items-start justify-start mb-2">
            <h1 className="text-lg font-bold">Profit & Loss</h1>
            <div className="text-sm font-extralight text-gray-500">
              Total of{" "}
              {USDollar.format((totals.income - totals.expenses).toFixed(0))}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col items-start justify-center text-xs gap-2">
        <div className="w-full flex flex-row items-center justify-between">
          <div className="flex flex-row items-center justify-start gap-2">
            <div className="w-3 h-3 bg-mila_orange rounded-sm"></div>
            <div className="text-zinc-600 flex flex-col items-start">
              <strong className="text-sm text-black">
                {USDollar.format(totals.income.toFixed(0))}
              </strong>{" "}
              Income
            </div>
          </div>
        </div>
        {(() => {
          const canCompare =
            (period?.label === "Month vs Month" ||
              period?.label === "Year vs Year") &&
            totals.compareMonth &&
            onCompareToggle;
          return (
            <div
              className={`w-full h-6 rounded-md overflow-hidden flex flex-row items-center justify-center ${
                canCompare ? "cursor-pointer hover:opacity-80 transition-opacity" : ""
              }`}
              onClick={(event) => {
                if (!canCompare) {
                  event.preventDefault();
                  event.stopPropagation();
                  return;
                }
                onCompareToggle(totals);
              }}
            >
          <div className="h-8 flex-1 bg-mila_orange"></div>
          <div className={`h-8 w-full bg-mila_orange`}></div>
            </div>
          );
        })()}
      </div>
      <div className="w-full flex flex-col items-start justify-center text-xs gap-2 mt-2">
        <div className="w-full flex flex-row items-center justify-between">
          <div className="flex flex-row items-center justify-start gap-2">
            <div className="w-3 h-3 bg-primary rounded-sm"></div>
            <div className="text-zinc-600 flex flex-col items-start">
              <strong className="text-sm text-black">
                {USDollar.format(totals.expenses.toFixed(0))}
              </strong>{" "}
              Expenses
            </div>
          </div>
        </div>
        <div className="w-full h-6 rounded-md overflow-hidden flex flex-row items-center justify-start bg-primary/5">
          <div
            className={`h-8 bg-primary`}
            style={{
              width: ((totals.expenses / totals.income) * 100).toFixed(0) + "%",
              minWidth: "10%",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
